/**
 * m3 echo Frontend - Onboarding API Service
 *
 * Thin API client for the onboarding endpoints used by the
 * OnboardingWizard / OnboardingPage.
 */

import apiClient from './api';

export interface OnboardingStatus {
  completed: boolean;
  current_step: number;
}

export interface OnboardingActionResponse {
  success: boolean;
  message: string;
}

export const onboardingApi = {
  /**
   * Get current onboarding status for the authenticated user.
   */
  getStatus: () =>
    apiClient.get<OnboardingStatus>('/onboarding/status'),

  /**
   * Persist the current onboarding step index.
   */
  updateStep: (step: number) =>
    apiClient.post<OnboardingActionResponse>('/onboarding/step', { step }),

  /**
   * Mark onboarding as completed.
   */
  complete: () =>
    apiClient.post<OnboardingActionResponse>('/onboarding/complete'),

  /**
   * Skip onboarding (also marks it as completed).
   */
  skip: () =>
    apiClient.post<OnboardingActionResponse>('/onboarding/skip'),
};

export default onboardingApi;
